import React from "react";
import OrderTable from "./OrderTable";
import sellingimage from "@images/sellingImages.png";
import ChartsComponent from "./ChartsComponent";
import { useBestSeller, useOrders } from "@hooks/orders/useOrder";
import { MenuItem } from "types/orders/orderTypes";

const ProductCard: React.FC<{ product: MenuItem }> = ({ product }) => {
  return (
    <>
      <div className="product-card">
        <div>
          <img src={product.imageUrl} alt={product.itemName} style={{width:"70px",height:"70px"}} />
        </div>
        <div className="product-info">
          <div>
            <p style={{ fontSize: "16px",whiteSpace:"nowrap" }}>{product.itemName}</p>
          </div>
          <div>
            <p style={{ color: "#FA4A0C",fontSize:"16px" }}>₹{product.price.toFixed(2)}</p>
          </div>
        </div>
      </div>
      {/* <div className="product-card">
        <img src={product.imageUrl} alt={product.name} />
        <div className="product-info">
          <h4>{product.name}</h4>
          <p>{product.price}</p>
        </div>
      </div> */}
    </>
  );
};
interface Orderprops{
  id:string;
}
const TotalOrders:React.FC<Orderprops> = (id) => {
  const {data,isLoading,error}=useOrders(String(id.id));
  const {data:bestSeller,isLoading:bestLoader}=useBestSeller(String(id.id));
  console.log("best",bestSeller);
  if(isLoading || !data){return<> isLoading...</>}
  return (
    <div style={{height:"65vh"}}>
      <div className='total-table-container'>
        <OrderTable  content={data?.content || []} totalPages={data?.totalPages} totalElements={data?.totalElements} last={data?.last} size={data?.size} number={0} sort={[]} numberOfElements={data?.numberOfElements} first={data?.first} empty={false} />
      </div>
      <div style={{ marginTop: "20px" }}>
        <h2 className="bestsellingtitle">Best Selling Items</h2>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap:"10px",
          }}
        >
          {bestSeller && bestSeller?.map((product:MenuItem) => (
            <ProductCard key={product.categoryId} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TotalOrders;
